<app-vehicle-list (mySelected)='list_onSelected($event)'></app-vehicle-list>